import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FilterGroup } from "./FilterGroup";
import { CitiesFilterGroup } from "./CitiesFilterGroup"; // NEW IMPORT

const FilterSidebar = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // Initialize state from URL params
    const [selectedStateIds, setSelectedStateIds] = useState(() => {
        const statesParam = searchParams.get('states');
        return statesParam ? statesParam.split(',').filter(Boolean) : [];
    });

    const [selectedCitiesIds, setSelectedCitiesIds] = useState(() => {
        const citiesParam = searchParams.get('cities');
        return citiesParam ? citiesParam.split(',').filter(Boolean) : [];
    });


    // Centralized URL param management
    useEffect(() => {
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev);

            // Update states param
            if (selectedStateIds && selectedStateIds.length > 0) {
                newParams.set('states', selectedStateIds.join(','));
            } else {
                newParams.delete('states');
            }

            // Update cities param
            if (selectedCitiesIds && selectedCitiesIds.length > 0) {
                newParams.set('cities', selectedCitiesIds.join(','));
            } else {
                newParams.delete('cities');
            }

            return newParams;
        }, { replace: true });
    }, [selectedStateIds, selectedCitiesIds, setSearchParams]);


    return (
        <div className="p-4 bg-gradient-radial rounded-xl">
            {/* Filter Header */}
            <h3 className="text-lg font-semibold text-white mb-2 flex justify-between items-center pb-2 border-b border-dashed border-gray-600">
                Filter
                <img src="/assets/gym-trainer-list/filters.png" className="h-6 w-6" alt="filters" />
            </h3>

            {/* States Filter Group */}
            <FilterGroup title="States" name="states" value={selectedStateIds} onChangeValue={setSelectedStateIds} apiUrl={`states/2`} />

            {/* CITIES FILTER COMPONENT */}
            <CitiesFilterGroup
                selectedStateIds={selectedStateIds}
                selectedCitiesIds={selectedCitiesIds}
                setSelectedCitiesIds={setSelectedCitiesIds}
            />

        </div>
    )
}

export { FilterSidebar }